module.exports = __webpack_public_path__ + "static/media/18.4dcd0e30.png";